import { render } from "./Missing.vue?vue&type=template&id=245fcf74&scoped=true"
import script from "./Missing.vue?vue&type=script&lang=js"
export * from "./Missing.vue?vue&type=script&lang=js"

import "./Missing.vue?vue&type=style&index=0&id=245fcf74&lang=scss&scoped=true"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/certificate-site-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245fcf74"]])

export default __exports__